import { environment } from "../config/environment";
import { fetchJson } from "../../fetch";
import { LocalStorageService } from "./LocalStorage";
import { isServer } from "../../utils";

export type NotificationBannerEvent = {
  text: string;
  showNotification: boolean;
  key: string;
  eventName: string;
  eventDateStart: string;
  eventDateEnd: string;
  gameIDs?: string[];
};

const emptyNotificationBanner: NotificationBannerEvent = {
  text: "",
  showNotification: false,
  key: "",
  eventName: "",
  eventDateStart: "",
  eventDateEnd: "",
};

export class NotificationBannerService {
  public static getNotificationBanner(): Promise<NotificationBannerEvent[]> {
    return fetchJson(
      `${environment.AARP_CONST_BLOB}/${environment.AARP_ENV}/json/NotificationBanner.json`,
      { timeout: 10 * 1000 }
    )
      .then((response) => {
        const today = new Date().getTime();
        return response.filter((notificationBanner) => {
          const firstEventDate = new Date(
            notificationBanner.eventDateStart
          ).setHours(0, 0, 0);
          const lastEventDate = new Date(
            notificationBanner.eventDateEnd
          ).setHours(23, 59, 59);
          return firstEventDate <= today && lastEventDate >= today;
        });
      })
      .catch((err) => {
        console.error(err);
        return [
          {
            key: "default",
            text: "Error on get Events",
            eventName: "Error Event",
            eventDateStart: "01/01/2020",
            eventDateEnd: "01/02/2020",
            showNotification: false,
          },
        ];
      });
  }

  public static getEventByGame(
    allEvents: NotificationBannerEvent[],
    gameSlug: string
  ): NotificationBannerEvent {
    if (isServer) return emptyNotificationBanner;
    const gameCurrentBanner = allEvents.find((event) =>
      event.gameIDs?.includes(gameSlug)
    );
    if (!gameCurrentBanner) return emptyNotificationBanner;

    let clonedEvent = JSON.parse(JSON.stringify(gameCurrentBanner));
    const showNotf =
      clonedEvent.showNotification &&
      !LocalStorageService.getItem(gameCurrentBanner.key);
    clonedEvent = { ...clonedEvent, showNotification: showNotf };
    return clonedEvent;
  }
}
